import React from "react";
import { useNavigate } from "react-router-dom";
import { getDisplayValue } from "../../../utils/displayValue";

function Table({ applications = [] }) {
  const navigate = useNavigate();

  // Decide the style classes based on the status
  const getStatusStyles = (status) => {
    const baseClasses = "inline-block text-center px-2 py-2 w-24";

    switch (status) {
      case "Pending":
        return `${baseClasses} text-xs bg-blue-200 text-blue-800`;
      case "In Process":
        return `${baseClasses} text-xs bg-yellow-200 text-yellow-800`;
      case "Accepted":
        return `${baseClasses} text-xs bg-green-200 text-green-800`;
      case "Rejected":
        return `${baseClasses} text-xs bg-red-200 text-red-800`;
      default:
        return `${baseClasses} text-xs bg-gray-200 text-gray-800`; // fallback style
    }
  };

  const formatDate = (isoString) => {
    return new Date(isoString).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="flex flex-col space-y-6 w-full">
      <div className="px-10 py-6 bg-white rounded shadow-md">
        <h2 className="text-lg font-bold text-gray-500 mb-4">My Applications</h2>

        <table className="w-full table-auto border-t border-b border-gray-300">
          <thead>
            <tr className="border-b border-gray-300">
              <th className="pr-4 py-2 text-center text-gray-400">Application Id</th>
              <th className="px-4 py-2 text-center text-gray-400">Date of Submission</th>
              <th className="px-4 py-2 text-center text-gray-400">University</th>
              <th className="px-4 py-2 text-center text-gray-400">City</th>
              <th className="px-4 py-2 text-center text-gray-400">Consultant Name</th>
              {/* <th className="px-4 py-2 text-center text-gray-400">Major</th> */}
              <th className="px-4 py-2 text-center text-gray-400">Status</th>
            </tr>
          </thead>

          {applications.length > 0 ? (
            <tbody>
              {applications.map((application) => {
                const statusClasses = getStatusStyles(application.status);
                const formattedDate = formatDate(application.applicationDate);

                return (
                  <tr key={application._id}
                    className="border-b border-gray-300 hover:bg-gray-50 cursor-pointer"
                    onClick={() => navigate("/application-details", { state: { id: application._id } })}
                  >
                    <td className="pr-4 py-4 text-gray-700 text-sm text-center">
                      {getDisplayValue(application.customApplicationId, "")}
                    </td>
                    <td className="px-4 py-4 text-gray-700 text-sm text-center">
                      {formattedDate}
                    </td>
                    <td className="px-4 py-4 text-gray-700 text-sm text-center">
                      {getDisplayValue(application.university)}
                    </td>
                    <td className="px-4 py-4 text-gray-700 text-sm text-center">
                      {getDisplayValue(application.city, "")}
                    </td>
                    <td className="px-4 py-4 text-gray-700 text-sm text-center">
                      {getDisplayValue(application.consultantName, "TBD")}
                    </td>
                    {/* <td className="px-4 py-4 text-gray-700 text-sm text-center">
                      {getDisplayValue(application.major, "")}
                    </td> */}
                    <td className="px-4 py-4 text-center">
                      <span className={`px-4 py-3 rounded-full ${statusClasses}`}>
                        {getDisplayValue(application.status, "")}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="6" className="px-4 py-4 text-sm text-gray-400 font-thin text-center">
                  No applications found.
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
}

export default Table;
